import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { isTablet, isMobile } from "react-device-detect";
import rotateScreen from "../assets/images/icons/rotate_screen.gif";
import { setToSessionStorage } from "../hooks/useSessionStorage";
import { setColor, setFont } from "../assets/styles/styles";

function GenericTCModal({ vanityLinkData, setAcceptedTerms, setCheckboxStatus, selectorScreenPage }) {
    const [checked, setChecked] = useState(true);

    const onTermsAccepted = () => {
        setAcceptedTerms(true);
        setCheckboxStatus(checked);
        setToSessionStorage("fullscreen", checked);

        // Stay on the same path. StartingPage will render DCV or Vagon in-place based on selectorScreenPage
    };

    if (vanityLinkData === undefined) {
        return null;
    }

    return (
        <TermsModalWrapper>
            <TermsModalContainer>
                {(isMobile || isTablet) && (
                    <RotateMobileContainer>
                        <RotateGif src={rotateScreen} alt="Rotate" />
                        <RotateText>
                            <span>ROTATE</span> your device to the right for the best experience.
                        </RotateText>
                    </RotateMobileContainer>
                )}
                <TermsModalTitle>Terms & Conditions</TermsModalTitle>
                <TermsModalText dangerouslySetInnerHTML={{ __html: vanityLinkData.termsAndConditionsText1 }} />
                <TermsModalText>
                    {vanityLinkData.termsAndConditionsText2}
                    <YellowText
                        href={vanityLinkData.termsAndConditionsLinkTZLink}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {vanityLinkData.tzName}{" "}
                    </YellowText>
                    and{" "}
                    <YellowText
                        href={vanityLinkData.termsAndConditionsClientLink}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {" "}
                        {vanityLinkData.clientName}.
                    </YellowText>
                </TermsModalText>
                <TermsModalButtons>
                    <TermsModalButtonDecline
                        alt="Decline"
                        // src={DeclineBtn}
                        onClick={() => {
                            window.location.reload();
                        }}
                    >
                        Decline
                    </TermsModalButtonDecline>
                    <TermsModalButtonAccept
                        alt="Accept"
                        type="button"
                        onClick={() => {
                            onTermsAccepted(checked);
                        }}
                    >
                        Accept & Continue
                    </TermsModalButtonAccept>
                </TermsModalButtons>
                {(localStorage.getItem("streaming.server") !== "dcv" ||
                    localStorage.getItem("streaming.override") === "vagon" ||
                    localStorage.getItem("streaming.server") === "vagon") && (
                    <TermsModalCheckbox isFullScreenDimension={isTablet || isMobile}>
                        <CheckboxFullscreen
                            type="checkbox"
                            onChange={() => setChecked((value) => !value)}
                            checked={checked}
                        />
                        <TermsCheckboxText>Start in full-screen mode</TermsCheckboxText>
                    </TermsModalCheckbox>
                )}
            </TermsModalContainer>
        </TermsModalWrapper>
    );
}

export default GenericTCModal;

const TermsModalWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5000;
`;

const TermsModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: ${setColor.darkBlue};
    padding: 40px;
    text-align: left;
    max-width: 400px;
    border-radius: 4px;
    border: 4px solid;
    border-color: ${setColor.purpleNavigation};
    margin: 20px;

    @media (max-width: 425px) {
        padding: 20px;
        background: linear-gradient(73deg, rgba(11, 11, 44, 0.75) 0%, rgba(33, 13, 53, 0.75) 98.54%);
        width: 100%;
        height: 100%;
        margin: 0px;
        border: none;
        max-width: 100%;
    }

    @media (max-height: 600px) and (orientation: landscape) {
        background: linear-gradient(73deg, rgba(11, 11, 44, 0.75) 0%, rgba(33, 13, 53, 0.75) 98.54%);
        width: 100%;
        height: 100%;
        margin: 0px;
        border: none;
        max-width: 100%;
    }
`;

const RotateGif = styled.img`
    height: auto;
    width: 120px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 5px 15px;

    @media (max-height: 600px) and (orientation: landscape) {
        width: 80px;
        height: auto;
    }
`;

const RotateMobileContainer = styled.div`
    height: fit-content;
    width: 100%;
    border-radius: 8px;
    background: rgba(190, 174, 255, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    margin-bottom: 40px;

    @media (max-height: 600px) and (orientation: landscape) {
        font-size: 20px;
        margin-bottom: 20px;
        text-align: left;
        margin-bottom: 10px;
        padding: 5px;
    }
`;
const RotateText = styled.div`
    /* width: 50%; */
    display: flex;
    justify-content: right;
    align-content: center;
    flex-direction: column;
    padding: 5px;
    text-align: left;
    font-family: ${setFont.barlow};
    color: #ffffff;

    > span {
        align-self: left;
        color: #beaeff;
        text-transform: uppercase;
        font-size: 24px;
        font-weight: 700;
        letter-spacing: 2px;
        margin-right: 8px;

        @media (max-height: 600px) and (orientation: landscape) {
            font-size: 20px;
        }
    }

    @media (max-height: 600px) and (orientation: landscape) {
        font-size: 16px;
    }
`;

const TermsModalTitle = styled.h2`
    font-size: 22px;
    margin-bottom: 30px;
    color: ${setColor.hightlight};
    text-align: center;
    font-family: ${setFont.signikaNegative};
    font-weight: 700;
    letter-spacing: 0;
    line-height: normal;
    @media (max-width: 600px) {
        font-size: 20px;
        margin-bottom: 20px;
        text-align: left;
    }

    @media (max-height: 600px) and (orientation: landscape) {
        font-size: 18px;
        margin-bottom: 5px;
        text-align: left;
    }
`;

const TermsModalText = styled.p`
    font-size: 16px;
    margin-bottom: 10px;
    color: ${setColor.hightlight};
    font-family: ${setFont.barlow};
    font-weight: 400;
    letter-spacing: 0;
    line-height: normal;

    & > strong {
        color: ${setColor.spanTextColor};
    }

    @media (max-width: 600px) {
        font-size: 16px;
    }

    @media (max-height: 600px) and (orientation: landscape) {
        font-size: 14px;
        margin-bottom: 12px;
    }
`;

const TermsCheckboxText = styled.p`
    font-size: 14px;
    margin: 0px 10px;
    padding-top: 2px;
    color: #ffffff;
    font-family: ${setFont.barlow};
    font-weight: 400;
    letter-spacing: 0;
    line-height: normal;

    & > strong {
        color: ${setColor.spanTextColor};
    }

    @media (max-width: 600px) {
        font-size: 14px;
    }

    @media (max-height: 600px) and (orientation: landscape) {
        font-size: 13px;
    }
`;

const TermsModalButtons = styled.div`
    display: flex;
    justify-content: space-between;
    padding-top: 10px;

    @media (max-width: 600px) and (orientation: portrait) {
        flex-direction: column;
    }

    @media (max-height: 600px) and (orientation: landscape) {
        padding-top: 5px;
    }
`;

const CheckboxFullscreen = styled.input`
    background-color: green;
    accent-color: ${setColor.lightPurpleCheckbox};
    font-size: 25px;
    transform: scale(1.5);
    margin: 0 10px;
`;

const TermsModalCheckbox = styled.div`
    display: flex;
    justify-content: flex-start;
    font-family: ${setFont.barlow};
    align-items: center;
    padding-top: 10px;
    color: white;
    margin-top: 0px;

    @media (max-width: 900px) {
        display: ${(props) => (props.isFullScreenDimension ? "none" : "flex")};
    }
`;

const TermsModalButtonDecline = styled.button`
    border: 1.5px solid #e4deff;
    background: rgba(255, 255, 255, 0.05);
    cursor: pointer;
    width: 48%;
    height: 45px;
    flex-shrink: 0;
    color: #e4deff;
    font-family: "Barlow", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0px;
    padding: 0 10px;

    @media (max-width: 600px) and (orientation: portrait) {
        height: 60px;
        width: 100%;
        font-size: 18px;
        align-self: center;
        margin-top: 20px;
    }
    @media (max-height: 600px) and (orientation: landscape) {
        height: 45px;
        font-size: 14px;
    }
`;
const TermsModalButtonAccept = styled.button`
    border: 1.5px solid #beaeff;
    background: rgba(37, 24, 89, 0.5);
    cursor: pointer;
    width: 48%;
    height: 45px;
    flex-shrink: 0;
    color: #e4deff;
    font-family: "Barlow", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    margin-bottom: 10px;
    letter-spacing: 0px;
    padding: 0 10px;

    @media (max-width: 600px) and (orientation: portrait) {
        height: 60px;
        width: 100%;
        font-size: 18px;
        align-self: center;
        margin-top: 20px;
    }
    @media (max-height: 600px) and (orientation: landscape) {
        height: 45px;
        font-size: 14px;
    }
`;

const YellowText = styled.a`
    color: ${setColor.spanTextColorThree};
    font-weight: 700;
    text-decoration: none;
    @media (max-width: 768px) {
        font-size: 14px;
    }
`;
